function Home () {
    return (
        <div className = "home">
            <h2>Welcome to the COVID-19 numbers page!</h2>
            <p>On this page, you can get the numerical data related to COVID-19 up to date.</p>
        </div>
    );
}

export default Home;